import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import config from '../../config.js'
import Member from '../models/instance/Member.js'

Vue.use(Vuex)

const addLoading = (state) => {
  Vue.set(state,'is_loading',true)
  var que;
  do {
    que = Math.floor((Math.random() * 1000000) + 1);
  } while(state.loading_que.includes(que))
  state.loading_que.push(que)
  return que
}

const finishLoading = (state,que) => {
  state.loading_que.splice(state.loading_que.indexOf(que), 1);
  if(state.loading_que.length == 0){
    Vue.set(state,'is_loading',false)
  }
}


export default new Vuex.Store({
  state: {
    is_loading : false
    ,loading_que : []
    ,station_code : null
    ,station_shortdetail : null
  },
  getters : {
    getStationShortDetail : (state) => (station_code) => {

      if(state.station_code != station_code){
        state.station_shortdetail = null
      }
      state.station_code = station_code

      if(state.station_shortdetail != null){
        return Promise.resolve(state.station_shortdetail)
      }else {
        var que = addLoading(state)
        return axios
        .post(config.api.url.public.station.get_stationshortdetail,{
          station_code : station_code
          ,lang:Member.getLang()
        })
        .then(response => {
          finishLoading(state,que)
          state.station_shortdetail = response.data;
          return state.station_shortdetail;
        })
      }
    }
  },
  mutations: {
    addLoading : addLoading
    ,finishLoading : finishLoading
  },
  actions: {
  },
  modules: {
  }
})
